// CATATAN: file ini saya tulis mandiri (axios instance sendiri) karena
// saya tidak punya isi "api/salesApi.ts" yang asli untuk dicontoh persis.
// Kalau proyekmu sudah punya axios client bersama (mis. "../lib/axios"
// atau "../api/axiosInstance"), ganti bagian `client` di bawah dengan
// import client itu supaya konsisten dengan salesApi.ts.

import axiosInstance from "../lib/axios";




export interface UserPayload {
  name: string;
  username: string;
  phone: string;
  email: string;
  password?: string;
  role: string;
}

export const getUsers = (params: { page: number; limit: number; search?: string }) =>
  axiosInstance.post("/User/List", params);

export const getUserById = (id: number) => axiosInstance.get(`/User/${id}`);

export const createUser = (payload: UserPayload) => axiosInstance.post("/User/Create", payload);

export const editUser = (id: number, payload: UserPayload) => axiosInstance.put(`/User/${id}`, payload);

export const deleteUserById = (id: number) => axiosInstance.delete(`/User/${id}`);